var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
/* eslint-disable no-fallthrough */
import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from 'tracked-built-ins';
import { guidFor } from '@ember/object/internals';
import { assert } from '@ember/debug';
export let SelectActions = /*#__PURE__*/function (SelectActions) {
  SelectActions[SelectActions["Close"] = 0] = "Close";
  SelectActions[SelectActions["CloseSelect"] = 1] = "CloseSelect";
  SelectActions[SelectActions["First"] = 2] = "First";
  SelectActions[SelectActions["Last"] = 3] = "Last";
  SelectActions[SelectActions["Next"] = 4] = "Next";
  SelectActions[SelectActions["Open"] = 5] = "Open";
  SelectActions[SelectActions["OpenFocus"] = 11] = "OpenFocus";
  SelectActions[SelectActions["PageDown"] = 6] = "PageDown";
  SelectActions[SelectActions["PageUp"] = 7] = "PageUp";
  SelectActions[SelectActions["Previous"] = 8] = "Previous";
  SelectActions[SelectActions["Select"] = 9] = "Select";
  SelectActions[SelectActions["Type"] = 10] = "Type";
  return SelectActions;
}({});
export const moveOperations = {
  [SelectActions.Next]: 1,
  [SelectActions.PageDown]: -10,
  [SelectActions.PageUp]: 10,
  [SelectActions.Previous]: -1
};
let TpkSelect = (_class = class TpkSelect extends Component {
  getActionFromKey(event) {
    const {
      key,
      altKey,
      ctrlKey,
      metaKey
    } = event;
    const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' ']; // all keys that will do the default open action

    if (!this.isOpen && openKeys.includes(key)) {
      if (key === 'ArrowUp') {
        return SelectActions.OpenFocus;
      }
      return SelectActions.Open;
    }

    // home and end move the selected option when open or closed
    if (key === 'Home') {
      return SelectActions.First;
    }
    if (key === 'End') {
      return SelectActions.Last;
    }
    if (key === 'Backspace' || key === 'Clear' || key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey) {
      return SelectActions.Type;
    }

    // handle typing characters when open or closed
    if (key === 'Backspace' || key === 'Clear' || key.length === 1 && key !== ' ' && !altKey && !ctrlKey && !metaKey) {
      return SelectActions.Type;
    }

    // handle keys when open
    if (this.isOpen) {
      if (key === 'ArrowUp' && altKey) {
        return SelectActions.CloseSelect;
      } else if (Object.keys(this.keyToOpenSelectAction).includes(key)) {
        return this.keyToOpenSelectAction[key];
      }
    }
    return;
  }
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isOpen", _descriptor, this);
    _initializerDefineProperty(this, "activeChildIndex", _descriptor2, this);
    _initializerDefineProperty(this, "children", _descriptor3, this);
    _initializerDefineProperty(this, "optionListId", _descriptor4, this);
    _initializerDefineProperty(this, "labelId", _descriptor5, this);
    _initializerDefineProperty(this, "controller", _descriptor6, this);
    _defineProperty(this, "searchString", '');
    _defineProperty(this, "typeTimer", void 0);
    _defineProperty(this, "keyToOpenSelectAction", {
      ArrowUp: SelectActions.Previous,
      ArrowDown: SelectActions.Next,
      PageUp: SelectActions.PageUp,
      PageDown: SelectActions.PageDown,
      Escape: SelectActions.Close,
      Enter: SelectActions.CloseSelect,
      ' ': SelectActions.CloseSelect,
      Tab: SelectActions.CloseSelect
    });
    _defineProperty(this, "guid", guidFor(this));
    assert('Please provide an @options array to component', args.options !== undefined);
    assert('Please provide an @onChange function', typeof args.onChange === 'function');
    if (this.args.multiple === true) {
      assert('Please provide an array for @selected', Array.isArray(args.selected));
    }
  }
  refreshChildren(e) {
    this.optionListId = e.id;
    this.children = Array.from(e.querySelectorAll('li'));
  }
  registerControllerDiv(d) {
    this.controller = d;
  }
  registerLabel(label) {
    this.labelId = label.id;
  }
  close() {
    this.isOpen = false;
    this.activeChildIndex = undefined;
  }
  navigate(action) {
    if (action === SelectActions.First) {
      this.activeChildIndex = 0;
      return;
    }
    if (action === SelectActions.Last) {
      this.activeChildIndex = this.children.length - 1;
      return;
    }
    if (this.activeChildIndex === undefined) {
      this.activeChildIndex = 0;
      return;
    }
    let value = moveOperations[action];
    const res = this.activeChildIndex + value;
    if (res > this.args.options.length - 1) {
      this.activeChildIndex = this.args.options.length - 1;
    } else if (res <= 0) {
      this.activeChildIndex = 0;
    } else {
      this.activeChildIndex = res;
    }
  }
  keyDown(event) {
    const action = this.getActionFromKey(event);
    switch (action) {
      case SelectActions.Last:
      case SelectActions.First:
        this.isOpen = true;
      case SelectActions.Next:
      case SelectActions.Previous:
      case SelectActions.PageUp:
      case SelectActions.PageDown:
        event.preventDefault();
        this.navigate(action);
        return;
      case SelectActions.Close:
        event.preventDefault();
        return this.close();
      case SelectActions.OpenFocus:
        this.activeChildIndex = 0;
      case SelectActions.Open:
        event.preventDefault();
        this.controller.focus();
        return this.isOpen = true;
      case SelectActions.Select:
      case SelectActions.CloseSelect:
        {
          console.log(this.activeChildIndex);
          if (this.activeChildIndex !== undefined && this.activeChildIndex >= 0) {
            const selectedOption = this.args.options[this.activeChildIndex ?? 0];
            this.close();
            return this.onChange(selectedOption, this.isElementSelected(selectedOption));
          } else {
            this.close();
            return this.args.onChange(event.target.value, false);
          }
        }
      case SelectActions.Type:
        return this.onComboType(event.key);
    }
    return;
  }

  /**
   * Handles typing on combobox
   */
  onComboType(letter) {
    this.isOpen = true;
    clearTimeout(this.typeTimer);
    this.typeTimer = setTimeout(() => {
      this.searchString = '';
      this.typeTimer = undefined;
    }, 400);
    if (letter === this.searchString[this.searchString.length - 1]) {
      this.searchString = letter;
      const nextChild = this.children[this.activeChildIndex + 1];
      if (nextChild.innerText.trim().startsWith(this.searchString)) {
        this.activeChildIndex++;
      } else {
        this.activeChildIndex = this.children.findIndex(c => {
          return c.innerText.trim().startsWith(this.searchString);
        });
      }
      return;
    }
    this.searchString += letter;
    const match = this.children.findIndex(c => {
      return c.innerText.trim().startsWith(this.searchString);
    });
    if (match !== -1) {
      this.activeChildIndex = match;
    } else {
      clearTimeout(this.typeTimer);
      this.searchString = '';
      this.typeTimer = undefined;
    }
  }
  isElementSelected(option) {
    if (this.args.multiple === true) {
      return this.args.selected.includes(option);
    }
    return this.args.selected === option;
  }
  onSelectButtonClick() {
    this.isOpen = !this.isOpen;
  }
  onChange(e, alreadySelected) {
    this.isOpen = false;
    this.args.onChange(e, alreadySelected);
  }
  get hasSelection() {
    return this.args.multiple === true ? this.args.selected.length > 0 : !!this.args.selected;
  }
  get activeChild() {
    return this.children[this.activeChildIndex ?? -1];
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isOpen", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "activeChildIndex", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "children", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "optionListId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "labelId", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "controller", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "refreshChildren", [action], Object.getOwnPropertyDescriptor(_class.prototype, "refreshChildren"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerControllerDiv", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerControllerDiv"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "registerLabel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "registerLabel"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "close", [action], Object.getOwnPropertyDescriptor(_class.prototype, "close"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "keyDown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "keyDown"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelectButtonClick", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectButtonClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype)), _class);
export { TpkSelect as default };